import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const DeleteIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg style={style} className={className} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.204 3.2h-3.185v-.8c0-1.325-1.07-2.4-2.39-2.4H7.038a2.394 2.394 0 0 0-2.389 2.4v.8H1.463a.798.798 0 0 0-.796.8c0 .442.356.8.796.8h.796v8.8c0 1.325 1.07 2.4 2.39 2.4h6.37a2.394 2.394 0 0 0 2.388-2.4V4.8h.797c.44 0 .796-.358.796-.8 0-.442-.357-.8-.796-.8zM6.24 2.4c0-.442.356-.8.796-.8H8.63c.44 0 .796.358.796.8v.8H6.24v-.8zm5.574 11.2c0 .442-.357.8-.796.8h-6.37a.798.798 0 0 1-.797-.8V4.8h7.963v8.8z"
        fillRule="evenodd"
      />
    </svg>
  )
})
